import { commonService } from '../../_services'
import { localStore } from '@/_utils/localstore'
import { WidgetModel } from '@/_models/WidgetModel'
import { EWidgetType } from '@/_enums/widget_setting'
const settingService = commonService('api/v1/setting')
const widgetSettingService = (sulfix: string = '') => commonService(`api/v1/widget-setting${sulfix}`)

const initialState = {
  item: {},
  widgets: [],
  rowCount: 0,
  loading: false,
}

const deepCloneInitial = JSON.parse(JSON.stringify(initialState))

export const settings = {
  namespaced: true,
  state: deepCloneInitial,
  actions: {
    async get(context: any): Promise<any> {
      context.commit('GET_REQUEST')

      return settingService
        .getAll()
        .then(resp => {
          context.commit('UPSERT_SETTING', resp.data)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('GET_FAILURE')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async getFromLocal(context: any): Promise<any> {
      const setting = JSON.parse(localStore.getItem('setting') as string)
      if (setting) {
        context.commit('UPSERT_SETTING', setting)
        return Promise.resolve(setting)
      }

      return context.dispatch('get').then(resp => {
        return Promise.resolve(resp)
      })
    },
    async update(context: any, data: any): Promise<any> {
      context.commit('UPDATE_REQUEST')

      return settingService
        .updateStatic(data)
        .then(resp => {
          return settingService.getAll().then(resp1 => {
            context.commit('UPSERT_SETTING', resp1.data)
            return Promise.resolve(resp1.data)
          })
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async getWidgetSettings(context: any): Promise<WidgetModel[]> {
      context.commit('GET_REQUEST')

      return widgetSettingService('/generate')
        .getAll()
        .then(resp => {
          context.commit('GET_WIDGET_SUCCESS', resp?.data?.data || resp?.data)
          context.commit('SET_COUNT_ROW_WIDGET', resp?.data?.rowCount)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('GET_WIDGET_FAILURE')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async getWidgetPersonalSettings(context: any): Promise<WidgetModel[]> {
      context.commit('GET_REQUEST')

      return widgetSettingService()
        .getAll({ type: EWidgetType.user_setting })
        .then(resp => {
          context.commit('GET_WIDGET_SUCCESS', resp?.data?.data || resp?.data)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('GET_WIDGET_FAILURE')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async addOneWidget(context: any, data: any): Promise<void> {
      context.commit('GET_REQUEST')

      return widgetSettingService()
        .addOne({ ...data, unit_id: context.rootState.authentication?.currentUser?.unit_id })
        .then(resp => {
          context.commit('ADD_WIDGET_SUCCESS', resp.data)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async updateOneWidget(context: any, data: any): Promise<void> {
      context.commit('GET_REQUEST')

      return widgetSettingService()
        .updateOne({ ...data, unit_id: context.rootState.authentication?.currentUser?.unit_id })
        .then(resp => {
          context.commit('UPDATE_WIDGET_SUCCESS', data)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async deleteOneWidget(context: any, id: any): Promise<void> {
      context.commit('GET_REQUEST')
      return widgetSettingService()
        .deleteOne(id)
        .then(resp => {
          context.commit('DELETE_WIDGET_SUCCESS', id)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
  },
  mutations: {
    GET_REQUEST(state: any) {
      state.loading = true
    },
    GET_FAILURE(state: any) {
      state.item = {}
      state.loading = false
    },
    UPDATE_REQUEST(state: any) {
      state.loading = true
    },
    UPSERT_SETTING(state: any, item: any) {
      state.item = item
      state.loading = false
      localStore.setItem('setting', JSON.stringify(item))
    },
    GET_WIDGET_SUCCESS(state: any, items: any) {
      state.widgets = items
      state.loading = false
    },
    SET_COUNT_ROW_WIDGET(state: any, count: number) {
      state.rowCount = count
    },
    GET_WIDGET_FAILURE(state: any) {
      state.widgets = []
      state.loading = false
    },
    ADD_WIDGET_SUCCESS(state: any, item: any) {
      state.widgets.push(item)
      state.loading = false
    },
    UPDATE_WIDGET_SUCCESS(state: any, item: any) {
      state.widgets = state.widgets.map(tmp => {
        return tmp._id === item._id ? item : tmp
      })

      state.loading = false
    },
    DELETE_WIDGET_SUCCESS(state: any, id: string) {
      const index = state.widgets.findIndex(item => item._id === id)
      if (index > -1) {
        state.widgets.splice(index, 1)
      }
      state.loading = false
    },
    REQUEST_ERROR(state: any) {
      state.loading = false
    },
    RESET_WIDGET(state: any) {
      state.widgets = []
      state.rowCount = 0
      state.laoding = false
    },
    RESET_STATE(state: any) {
      const init = JSON.parse(JSON.stringify(initialState))
      Object.keys(init).forEach(key => {
        state[key] = init[key]
      })
    },
  },
  getters: {
    canEdit: state => () => {
      return settingService.canEdit()
    },
    settingLoading: state => {
      return state.loading
    },
  },
}
